import { useQuery } from "@tanstack/react-query";
import ChessRestClient from "@/Api/ChessRestClient";

export const useJoinRequests = (clubId: number) =>
  useQuery(["clubs", "requests", clubId], async () =>
    (await ChessRestClient.get(`/api/clubs/${clubId}/requests/`)).data);

export const useClubInvites = (clubId: number) =>
  useQuery(["clubs", "invites", clubId], async () =>
    (await ChessRestClient.get(`/api/clubs/${clubId}/invites/`)).data);
